import { Autocomplete, Checkbox, FormControlLabel, Grid, MenuItem, Select, TextField } from '@mui/material';
import React, { createRef, useMemo } from 'react';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import { If } from '../../../common/IfComponent';
import { CostType, CostWeightType, ProductDto } from '../../../common/PricePrgClient';
import { RootState } from '../../../store';
import { getCostType } from '../calculationTypes';
import { getSelectedCalculationPricelistCurrency } from '../redux/calculationSelectors';
type OwnProps = {
    handleAmountChange: (val: number) => void;
    useBasePrice: boolean;
    handleUseBasePrice: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleProductChanged: (value: ProductDto | null) => void;
    amount: number;
    productId: number | undefined;
    costWeightType: CostWeightType | undefined;
    handleCostWeightTypeChanged: (costWeightType: CostWeightType) => void;
    costType: CostType;
};

const mapStateToProps = (state: RootState) => ({
    products: state.product.products,
    currency: getSelectedCalculationPricelistCurrency(state)
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const ProductCostDialogContent = ({
    handleAmountChange,
    handleUseBasePrice,
    handleProductChanged,
    handleCostWeightTypeChanged,
    useBasePrice,
    amount,
    productId,
    products,
    costType,
    currency,
    costWeightType
}: Props) => {
    const productValues = useMemo(() => Object.values(products), [products]);

    const amountInputRef = createRef();
    const getAmountLabel = () => {
        return getCostType(currency, costType!);
    };
    return (
        <div>
            <Grid container direction="column">
                <Autocomplete
                    onChange={(_, value) => handleProductChanged(value)}
                    value={productValues?.find(c => c.productId === productId) ?? null}
                    options={productValues}
                    getOptionLabel={product => `${product.productId} - ${product.name}`}
                    renderInput={params => <TextField {...params} label="" variant="outlined" fullWidth />}
                />

                <NumberFormat
                    style={{ padding: '6px 0 7px', marginTop: '12px' }}
                    getInputRef={amountInputRef}
                    customInput={TextField}
                    value={amount}
                    onValueChange={e => {
                        if (e.value === '') {
                            handleAmountChange(0);
                        }

                        if (e.floatValue != null) {
                            handleAmountChange(e.floatValue);
                        }
                    }}
                    decimalSeparator=","
                    thousandSeparator={false}
                    isNumericString={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    suffix={costType === CostType.ProductPercentage ? ' %' : ` ${getAmountLabel()}`}
                />
                <If
                    condition={costType === CostType.ProductPercentage}
                    then={
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={useBasePrice}
                                    onChange={handleUseBasePrice}
                                    name="useBasePrice"
                                    color="primary"
                                />
                            }
                            label="Calculate using base price"
                        />
                    }
                    else={
                        <Select
                            fullWidth
                            value={costWeightType ?? CostWeightType.GrossWeight}
                            label="Calculate on weight type"
                            onChange={e => handleCostWeightTypeChanged(e.target.value as CostWeightType)}
                            style={{ padding: '6px 0 7px', marginTop: '12px' }}
                        >
                            <MenuItem key={CostWeightType.GrossWeight} value={CostWeightType.GrossWeight}>
                                Gross weight
                            </MenuItem>
                            <MenuItem key={CostWeightType.NetWeight} value={CostWeightType.NetWeight}>
                                Net weight
                            </MenuItem>
                        </Select>
                    }
                />
            </Grid>
        </div>
    );
};

export default connect(mapStateToProps)(ProductCostDialogContent);
